import { useState } from "react"

export const MembershipState = () => {
	const [memberForm, setMemberForm] = useState({
		code: '', 
		name: '',
		membershipFee: 'free',
		regularPrice: 0,
		discount: 0,
		price: 0,
		hasVoucherCode: false,
		voucherCode: '',
		inclusions: [{id: '', value: '', remove: false}],
		membershipValidity: 0,
		exclusive: true,
		hasTransaction: false,
	})
    const dfltMemberForm = {
		code: '', 
		name: '',
		membershipFee: 'free',
		regularPrice: 0,
		discount: 0,
		price: 0,
		hasVoucherCode: false,
		voucherCode: '',
		inclusions: [{id: '', value: '', remove: false}],
		membershipValidity: 0, 
		exclusive: true,
		hasTransaction: false,
	}
    const [memberList, setMemberList] = useState([])
    const [memberLoader, setMemberLoader] = useState({ list: false, statusSaving: false, viewForm: false, formSaving: false })
    const [memberPage, setMemberPage] = useState(1)
    const [memberHasMore, setMemberHasMore] = useState(true)
	const [memberModals, setMemberModals] = useState({ form: false, confirmation: false })
	const [memberSelected, setMemberSelected] = useState({ id: '', active: false })
	const [memberMethod, setMemberMethod] = useState('')
	const [memberError, setMemberError] = useState(false)
	
    return {
		memberForm: {data: memberForm, set: setMemberForm},
        dfltMemberForm: {data: dfltMemberForm},
        memberList: {data: memberList, set: setMemberList},
        memberLoader: {data: memberLoader, set: setMemberLoader},
        memberPage: {data: memberPage, set: setMemberPage},
        memberHasMore: {data: memberHasMore, set: setMemberHasMore},
		memberModals: {data: memberModals, set: setMemberModals},
		memberSelected: {data: memberSelected, set: setMemberSelected},
		memberMethod: {data: memberMethod, set: setMemberMethod},
		memberError: {data: memberError, set: setMemberError},
    }
}